/* DTF combined order badge
   Sticky badge showing total DTF units in the cart and the current tier.

   - First paint uses the count Liquid writes into #li-cart-data
     (data-dtf-units, theme.liquid), so no /cart.js request on page load.
   - Refreshes only after a real cart change (/cart/add, change, update,
     clear), seen through PerformanceObserver so window.fetch is not wrapped
     again (li-order-store.js already wraps it).
   - Counts 'DTF' and 'Digital' lines, using Total units / Quantity when set,
     the same way the cart page does.
   - Hidden on /cart, which shows its own DTF minimum warning. */

(function () {
  var BADGE_ID = 'li-dtf-badge';
  var DTF_MINIMUM = 25;
  var TIERS = [
    { min: 250, label: '250+ units' },
    { min: 100, label: '100+ units' },
    { min: 50,  label: '50+ units'  },
    { min: 25,  label: '25+ units'  }
  ];
  var CART_CHANGE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var STALE_MS = 30000;

  var lastFetch = 0;
  var timer = null;

  function onCartPage() {
    return /^\/cart\/?$/.test(window.location.pathname);
  }

  function tierLabel(n) {
    for (var i = 0; i < TIERS.length; i++) {
      if (n >= TIERS[i].min) return TIERS[i].label;
    }
    return null;
  }

  function lineUnits(item) {
    var p = item.properties || {};
    var raw = p['Total units'];
    if (raw === undefined || raw === null || raw === '') raw = p['Quantity'];
    var n = parseInt(String(raw == null ? '' : raw).replace(/[^0-9]/g, ''), 10);
    return (isFinite(n) && n > 0) ? n : (item.quantity || 0);
  }

  function countDTF(cart) {
    var units = 0;
    ((cart && cart.items) || []).forEach(function (item) {
      var pm = (item.properties || {})['Print method'] || '';
      if (pm === 'DTF' || pm === 'Digital') units += lineUnits(item);
    });
    return units;
  }

  function injectStyles() {
    if (document.getElementById('li-dtf-badge-styles')) return;
    var s = document.createElement('style');
    s.id = 'li-dtf-badge-styles';
    s.textContent =
      '#li-dtf-badge{position:fixed;bottom:20px;right:20px;z-index:9998;' +
      'background:rgb(var(--color-button,180 117 23));color:rgb(var(--color-button-text,255 255 255));' +
      'border-radius:8px;padding:10px 16px;font-family:var(--font-body-family,sans-serif);' +
      'font-size:1.3rem;font-weight:600;box-shadow:0 4px 16px rgba(0,0,0,0.25);' +
      'display:none;flex-direction:column;align-items:center;gap:2px;min-width:130px;' +
      'text-align:center;cursor:pointer;transition:transform 0.15s,opacity 0.2s;text-decoration:none;}' +
      '#li-dtf-badge:hover{transform:scale(1.04);opacity:0.92;}' +
      '#li-dtf-badge.li-dtf-visible{display:flex;}' +
      '#li-dtf-badge .li-bdu{font-size:1.9rem;font-weight:700;line-height:1;}' +
      '#li-dtf-badge .li-bdl{font-size:1rem;opacity:0.75;letter-spacing:0.07em;text-transform:uppercase;}' +
      '#li-dtf-badge .li-bdt{font-size:1.1rem;font-weight:500;margin-top:1px;}' +
      '#li-dtf-badge .li-bdw{font-size:1rem;color:#ffe08a;margin-top:2px;}' +
      '@media (prefers-reduced-motion:reduce){#li-dtf-badge{transition:none;}#li-dtf-badge:hover{transform:none;}}';
    document.head.appendChild(s);
  }

  function getBadge() {
    var el = document.getElementById(BADGE_ID);
    if (!el) {
      el = document.createElement('a');
      el.id = BADGE_ID;
      el.href = '/cart';
      document.body.appendChild(el);
    }
    return el;
  }

  function render(units) {
    if (onCartPage() || !units) {
      var existing = document.getElementById(BADGE_ID);
      if (existing) existing.classList.remove('li-dtf-visible');
      return;
    }
    injectStyles();
    var badge = getBadge();
    var tier = tierLabel(units);
    var short = units < DTF_MINIMUM ? DTF_MINIMUM - units : 0;
    badge.innerHTML =
      '<span class="li-bdu">' + units + '</span>' +
      '<span class="li-bdl">DTF units</span>' +
      (tier ? '<span class="li-bdt">' + tier + '</span>' : '') +
      (short ? '<span class="li-bdw">&#9888; ' + short + ' more to meet minimum</span>' : '');
    badge.setAttribute('aria-label',
      units + ' DTF units in your order' +
      (short ? ', ' + short + ' more to meet the minimum' : '') +
      '. View order');
    badge.classList.add('li-dtf-visible');
  }

  function refresh() {
    if (onCartPage()) return;
    lastFetch = Date.now();
    var f = window._rawFetch || window.fetch;
    f('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(countDTF(cart)); })
      .catch(function () {});
  }

  function scheduleRefresh() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 300);
  }

  function initialUnits() {
    var data = document.getElementById('li-cart-data');
    var n = data ? parseInt(data.dataset.dtfUnits, 10) : NaN;
    return isFinite(n) ? n : null;
  }

  function start() {
    var n = initialUnits();
    if (n === null) refresh();   // data div missing: fall back to one fetch
    else render(n);
  }

  // Refresh after real cart changes only
  if (window.PerformanceObserver) {
    try {
      new PerformanceObserver(function (list) {
        var entries = list.getEntries();
        for (var i = 0; i < entries.length; i++) {
          if (CART_CHANGE.test(entries[i].name)) { scheduleRefresh(); return; }
        }
      }).observe({ type: 'resource', buffered: false });
    } catch (e) {
      window.addEventListener('li:order:updated', scheduleRefresh);
    }
  } else {
    window.addEventListener('li:order:updated', scheduleRefresh);
  }

  // Back/forward cache restores a stale page; another tab may have changed the cart
  window.addEventListener('pageshow', function (e) { if (e.persisted) scheduleRefresh(); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible' && Date.now() - lastFetch > STALE_MS) {
      lastFetch = Date.now();
      scheduleRefresh();
    }
  });

  window.liUpdateDTFBadge = scheduleRefresh;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
